import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
} from '@angular/router';

import { routes } from './app.routes';

import { providePrimeNG } from 'primeng/config';
import { d2dTheme } from './layout/d2d-theme';
import { tokenInterceptor } from '@core/interceptors/token/token.interceptor';
import { userIdInterceptor } from '@core/interceptors/user-id/user-id.interceptor';
import { errorInterceptor } from '@core/interceptors/error/error.interceptor';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { ChunkLoadErrorHandler } from '@core/handlers/chunk-load-error.handler';
import { EnvironmentService } from '@core/services/environment/environment.service';
import { PermissionsService } from '@core/services/permissions/permissions.service';
import { SessionService } from '@core/services/session/session.service';
import { NavigationService } from '@core/services/navigation/navigation.service';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'top',
      }),
      withEnabledBlockingInitialNavigation(),
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([tokenInterceptor, userIdInterceptor, errorInterceptor]),
    ),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: d2dTheme,
        options: {
          darkModeSelector: '.app-dark',
        },
      },
    }),
    MessageService,
    DialogService,
    ConfirmationService,
    provideAppInitializer(() => {
      const env = inject(EnvironmentService);
      const session = inject(SessionService);
      const perms = inject(PermissionsService);
      // Instancia temprana para trackear el historial de navegación desde el arranque.
      inject(NavigationService);

      if (env.isServer()) return Promise.resolve();
      if (!session.getActiveSession()?.token) return Promise.resolve();
      return perms.loadEffectivePermissions();
    }),
  ],
};
